import { cn } from "../../lib/utils";

/** Heading pattern: light-weight headline, 1–3 gradient accent words. */
export function SectionHeading({
  eyebrow,
  lead,
  accent,
  sub,
  align = "center",
  as: Tag = "h2",
  dark = false,
  className,
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3",
        align === "center"
          ? "mx-auto max-w-3xl items-center text-center"
          : "items-start text-left",
        className
      )}
    >
      {eyebrow && (
        <p
          className={cn(
            "text-sm font-semibold tracking-wide uppercase",
            dark ? "text-brand-bright" : "text-brand-text"
          )}
        >
          {eyebrow}
        </p>
      )}

      <Tag
        className={cn(
          "text-[22px] leading-[1.35] font-normal text-balance sm:text-[26px] lg:text-[32px] lg:leading-[1.25] xl:text-[34px]",
          dark && "text-on-dark"
        )}
      >
        {lead}

        {accent && (
          <>
            {" "}
            <span
              className={cn(
                "font-semibold",
                dark ? "text-brand-bright" : "text-gradient-brand"
              )}
            >
              {accent}
            </span>
          </>
        )}
      </Tag>

      {sub && (
        <p
          className={cn(
            "max-w-2xl text-base leading-[1.85] font-light",
            dark ? "text-on-dark-muted" : "text-muted-foreground"
          )}
        >
          {sub}
        </p>
      )}
    </div>
  );
}